
    <div class="iwg-summary" layout="row" layout-xs="column" *ngIf="summary1">
        <div flex *ngFor="let item of summary1" [ngClass]="{'iwg-summary-item-selected': (selectedSummaryItem?.FilterName == item.FilterName
                        && selectedSummaryItem?.FilterValue == item.FilterValue)}" (click)="changeSummary(item)">
            <div class="iwg-value">{{item.Value}}</div>
            <div class="iwg-label">{{item.Name}}</div>
        </div>
    </div>
    <div>
        
        <div fxLayout="row" fxLayout.xs="column" fxLayoutAlign="space-between center" fxLayout.lt-sm="column"
            fxLayoutAlign.lt-sm="start" class="iwg-grid-filters mat-padding mlr-15" filterSection style="float: right;">
            <div fxFlex="100">
                <span class="ml-10 mobile-downloadbtn">
                    <button mat-icon-button aria-hidden="false" aria-label="Download" class="inputassignicon"
                        (click)="exportTable()">
                        <mat-icon>file_download</mat-icon>
                    </button>
                </span>
            </div>

        </div>
      
    </div>

  
    <div class="wrapper1" #wrapper1>
        <div class="div1" #div1></div>
    </div>
    <div class="wrapper2" #wrapper2>
       
        <div class="div2" #div2>
            <mat-progress-bar color="accent" mode="indeterminate" *ngIf="loading"></mat-progress-bar>
            <mat-table #listTable matTableExporter matSort [dataSource]="dataSource" #exporter="matTableExporter"
                [hiddenColumns]="hideColsInExport" (matSortChange)="sortData($event)" style="min-width: 100%;">

                <ng-container matColumnDef="DocumentID">
                    <mat-header-cell *matHeaderCellDef mat-sort-header disableClear>Document ID</mat-header-cell>
                    <mat-cell *matCellDef="let documents">
                        <span class="purple cursor" *ngIf="documents.AssignmentStatusID == 14 && documents.DocumentStatusID == 1" (click)="showDocumentDialog($event,documents.EvaluationDocumentTypeID,documents.DocumentTypeID,documents.DocumentTypeName)">
                            {{documents.DocID}}</span>
                        <span class="purple" *ngIf="documents.DocumentStatusID != 1 || documents.AssignmentStatusID != 14">
                            {{documents.DocID}}</span>
                    </mat-cell>
                </ng-container>


                <ng-container matColumnDef="DocumentType">
                    <mat-header-cell *matHeaderCellDef mat-sort-header disableClear>Document Type</mat-header-cell>
                    <mat-cell *matCellDef="let documents">
                        <span class="purple cursor" *ngIf="documents.AssignmentStatusID == 14 && documents.DocumentStatusID == 1" (click)="showDocumentDialog($event,documents.EvaluationDocumentTypeID,documents.DocumentTypeID,documents.DocumentTypeName)">
                            {{documents.DocumentTypeName}}</span>
                        <span class="purple" *ngIf="documents.AssignmentStatusID != 14 || documents.DocumentStatusID != 1">
                            {{documents.DocumentTypeName}}</span>
                    </mat-cell>
                </ng-container>

                <ng-container matColumnDef="DocumentName">
                    <mat-header-cell *matHeaderCellDef mat-sort-header disableClear>Document Name
                    </mat-header-cell>
                    <mat-cell *matCellDef="let documents"> {{documents.DocumentName}} </mat-cell>
                </ng-container>

                <ng-container matColumnDef="Notes">
                    <mat-header-cell *matHeaderCellDef mat-sort-header disableClear>Notes
                    </mat-header-cell>
                    <mat-cell *matCellDef="let documents"> {{documents.Notes}} </mat-cell>
                </ng-container>

                <ng-container matColumnDef="DateReceived">
                    <mat-header-cell *matHeaderCellDef mat-sort-header disableClear>Date Received</mat-header-cell>
                    <mat-cell *matCellDef="let documents"> {{documents.ReceivedDate | date:'MM/dd/yyyy'}} </mat-cell>
                </ng-container>

                <ng-container matColumnDef="DateIssued">
                    <mat-header-cell *matHeaderCellDef mat-sort-header disableClear>Date Issued</mat-header-cell>
                    <mat-cell *matCellDef="let documents"> {{documents.IssuedDate | date:'MM/dd/yyyy'}} </mat-cell>
                </ng-container>

                <ng-container matColumnDef="ExpirationDate">
                    <mat-header-cell *matHeaderCellDef mat-sort-header disableClear>Expiration Date</mat-header-cell>
                    <mat-cell *matCellDef="let documents">{{documents.ExpireDate | date:'MM/dd/yyyy'}} </mat-cell>
                </ng-container>

               
                <ng-container matColumnDef="Upload">
                    <mat-header-cell *matHeaderCellDef disableClear class="mat-boldView">Upload</mat-header-cell>
                    <mat-cell *matCellDef="let documents">
                        <button mat-button class="mat-icon-button" aria-label="More"
                            *ngIf="documents.AssignmentStatusID == 14 && documents.DocumentStatusID == 1"
                            style="padding-left: 0px;"
                            (click)="showDocumentDialog($event,documents.EvaluationDocumentTypeID,documents.DocumentTypeID,documents.DocumentTypeName)">
                            <mat-icon>file_upload</mat-icon>
                        </button>
                    </mat-cell>
                </ng-container>

                <ng-container matColumnDef="Download">
                    <mat-header-cell *matHeaderCellDef disableClear class="mat-boldView">Download
                    </mat-header-cell>
                    <mat-cell *matCellDef="let documents">
                        <button mat-button class="mat-icon-button" aria-label="More" style="padding-left: 0px;"
                            *ngIf="documents.DocumentFileIDs != null && documents.DocumentFileIDs != ''"
                            (click)="downloadAllForDocument(documents.EvaluationDocumentTypeID)">
                            <mat-icon>file_download</mat-icon>
                        </button>
                    </mat-cell>
                </ng-container>

                <ng-container matColumnDef="DoesNotHave">
                    <mat-header-cell *matHeaderCellDef disableClear class="mat-boldView">Does Not Have</mat-header-cell>
                    <mat-cell *matCellDef="let documents">
                        <button mat-button class="mat-icon-button" aria-label="More"
                            *ngIf="documents.AssignmentStatusID == 14 && (documents.DocumentStatusID == 1 || documents.DocumentStatusID == 4)"
                            [disabled]="documents.DocumentStatusID == 4" style="padding-left: 0px;"
                            (click)="changeToDoesNotHave($event,documents.EvaluationDocumentTypeID,documents.DocumentTypeID)">
                            <mat-icon class="{{( documents.DocumentStatusID == 4) ? 'grey-icon' : ''}}">not_interested</mat-icon>
                        </button>
                    </mat-cell>
                </ng-container>

                <ng-container matColumnDef="UploadedBy">
                    <mat-header-cell *matHeaderCellDef mat-sort-header disableClear>Uploaded By
                    </mat-header-cell>
                    <mat-cell *matCellDef="let documents"> {{documents.UploadedByName}} </mat-cell>
                </ng-container>

                <ng-container matColumnDef="Status">
                    <mat-header-cell *matHeaderCellDef mat-sort-header disableClear>Status
                    </mat-header-cell>
                    <mat-cell *matCellDef="let documents"> {{documents.StatusName}}</mat-cell>
                </ng-container>
               
                <ng-container matColumnDef="OprMenu">
                    <mat-header-cell *matHeaderCellDef class="hidexs"></mat-header-cell>
                    <mat-cell *matCellDef="let documents" class="hidexs">
                        <button mat-icon-button [matMenuTriggerFor]="elementMenu" aria-label="Menu" [disabled]="documents?.AssignmentStatusID != 14 || documents?.DocumentStatusID != 1">
                            <mat-icon>more_vert</mat-icon>
                        </button>

                        <mat-menu #elementMenu="matMenu" class="submenu" let document>
                           
                            <button mat-menu-item *ngIf="documents?.DocumentStatusID==1"
                                (click)="showDocumentDialog($event,documents?.EvaluationDocumentTypeID,documents?.DocumentTypeID,documents?.DocumentTypeName)">
                                Upload
                            </button>
                            <button mat-menu-item
                            *ngIf="documents?.DocumentStatusID==1 && documents?.DocumentStatusID!=4"
                                (click)="changeToDoesNotHave($event,documents?.EvaluationDocumentTypeID,documents?.DocumentTypeID)">
                                Does Not Have
                            </button>
                            <button mat-menu-item
                                *ngIf="documents?.EvaluationDocumentTypeID > 0 && documents?.StatusName!='Archive'"
                                style="display:none"
                                (click)="archieveDocument($event,documents?.EvaluationDocumentTypeID,documents?.DocumentTypeID)">
                                Archive
                            </button>
                            <button mat-menu-item *ngIf="documents?.StatusName=='Archive'" style="display:none"
                                (click)="unArchieveDocument($event,documents?.EvaluationDocumentTypeID,documents?.DocumentTypeID)">
                                UnArchive
                            </button>
                        </mat-menu>

                    </mat-cell>
                </ng-container>
                <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
                <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
            </mat-table>

        </div>
    </div>

    <mat-paginator [length]="totalRecords" [pageSize]="state.limit" class="myvista-paginator"
                   (page)="pageEvent = $event; naviatePageTo($event)" [pageSizeOptions]="[25, 100, 500, 1000, 10000]"
                   showFirstLastButtons>
    </mat-paginator>
    <div layout="row" class="iwg-form-buttons" style="margin: auto;">
   
        <button mat-button (click)="showDocumentDialog($event,null,null,'Other')" style="background-color: #224d95; color: rgba(255,255,255,0.87);margin-right: 20px;
        margin-top: 20px;box-shadow: 0 2px 5px 0 rgba(0,0,0,.26);" *ngIf="AssignmentStatusId == 14">
            Add Additional Document
        </button>
        <button mat-button class="mat-primary mat-raised iwg-mat-raised" (click)="DownloadAllAttachments()"
            style="background-color: #224d95;box-shadow: 0 2px 5px 0 rgba(0,0,0,.26); color: rgba(255,255,255,0.87)">
            Download all Files
        </button>
    </div>
